<template>
  <div>
    <div class="bg-custom-blue">
      <div class="container">
        <div class="row py-2">

          <!-- Switch Conversion  -->
          <div class="form-check form-switch mx-4 py-2 col-3">
            <input v-model="switchConversion" type="checkbox" role="switch" id="switchConversion" class="form-check-input">
            <label class="switchConversion" for="switchConversion">{{ $t("views.my.tasks.switchConversion") }}</label>
          </div>

          <div class="col d-flex justify-content-end gap-3">

            <!-- Filter Responsible  -->
              <select v-model="filterResponsible" class="form-select form-select-sm w-auto">
                <option value=""> {{ $t("views.measure.tracking.filterAllResponsibles") }} </option>
                <option v-for="employee in uniqueResponsibles" :key="employee" :value="employee" > {{ employee }} </option>
              </select>

            <!-- Filter Due-Date -->
              <select v-model="filterDue" class="form-select form-select-sm w-auto">
                <option value=""> {{ $t("views.measure.tracking.filterDue.noFilter") }} </option>
                <option value="overdue"> {{ $t("views.measure.tracking.filterDue.overdue") }}</option>
                <option value="7"> {{ $t("views.measure.tracking.filterDue.7days") }} </option>
                <option value="30"> {{ $t("views.measure.tracking.filterDue.30days") }} </option>
                <option value="90"> {{ $t("views.measure.tracking.filterDue.90days") }} </option>
              </select>

            <!-- Search Measure-Title -->
              <input v-model="filterName" type="text" class="form-control form-control-sm w-auto" :placeholder='$t("general.placeholderSearch")'>

          </div>
        </div>
      </div>
    </div>

    <div v-if="filteredTasks.length" class="container my-3">
      <!-- Title & Infobutton-->
      <div class="row">
        <div class="col-12">
          <div class="h4">
            {{ $t("views.measure.tracking.headingTitle") }}
          </div>
        </div>
      </div>

      <div class="bg-white rounded-2 p-2 mt-4">

        <!-- Spaltenüberschriften -->
        <div class="row">
          <div class="col-12">
            <div class="">
              <div class="row fw-bold px-3 border-bottom py-2">
                <div class="col-4 px-1">
                  {{ $t("views.measure.tracking.measureTitle") }}
                </div>
                <div class="col-2 px-1">
                  {{ $t("views.measure.tracking.measureResponsible") }}
                </div>
                <div class="col-1 px-1">
                  {{ $t("views.measure.tracking.measureConversion") }}
                </div>
                <div class="col-1 text-start px-1">
                  {{ $t("views.measure.tracking.measureValidFrom") }}
                </div>
                <div class="col-1 text-start px-1">
                  {{ $t("views.measure.tracking.measureValidTo") }}
                </div>
                <div class="col-3 text-start px-1">
                  {{ $t("views.measure.tracking.measureRelatedObject") }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Spalteninhalte -->
        <div class="row">
          <div class="col-12">
            <div v-for="task in filteredTasks" :key="task.id" class="row px-3 border-bottom">
                <div class="col-4 my-auto col-measure-name px-1 py-2">
                  {{ task.title }}
                </div>
                <div class="col-2 my-auto col-measure-name px-1 py-2">
                  {{ task.responsible.name }}
                </div>
                <div class="col-1 my-auto px-1">
                  <div class="progress position-relative border bg-dark border-dark w-50">
                    <span class="progress-label position-absolute start-50 top-50 text-light fw-bold">{{ 25 * task.conversion }}%</span>
                    <div class="progress-bar progress-bar-striped bg-primary" :style="'width: ' + (25 * task.conversion) + '%'" role="progressbar" :aria-valuenow="(25 * task.conversion)" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </div>
                <div class="col-1 my-auto text-start px-1 py-2">
                  {{ formatDate(new Date(task.validFrom)) }}
                </div>
                <div class="col-1 my-auto text-start px-1 py-2" :class="new Date(task.validTo) < new Date() ? 'text-danger' : 'text-dark'">
                  {{ formatDate(new Date(task.validTo)) }}
                </div>
                <!-- verbundene Objekte -->
                <div class="col my-auto text-start px-1 py-2 text-break">
                  <div v-if="task.type === 'objective'" >
                    <svg class="bi" width="16" height="16" fill="currentColor" v-tooltip="'tooltip.iconObjective'"> <use xlink:href="@/assets/icons/icons.svg#objective" /> </svg> &nbsp;
                    <a :href="createLink('objective', task.objectiveUuid)" target="_blank"> {{ task.category === 1 ? task.name.toUpperCase() : task.name }} </a>
                  </div>
                  <div v-if="task.type === 'project'" >
                    <svg class="bi" width="16" height="16" fill="currentColor" v-tooltip="'tooltip.iconProject'"> <use xlink:href="@/assets/icons/icons.svg#project" /> </svg> &nbsp;
                    <a :href="createLink('project', task.projectUuid)" target="_blank"> {{ task.name }} </a>
                  </div>
                  <div v-if="task.type === 'strategy'" >
                    <svg class="bi" width="16" height="16" fill="currentColor" v-tooltip="'tooltip.iconStrategy'"> <use xlink:href="@/assets/icons/icons.svg#strategy" /> </svg> &nbsp;
                    <a :href="createLink('strategy', task.strategyUuid)" target="_blank"> {{ task.name }} </a>
                  </div>
                </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- Fehlermeldung "No Data"          -->
    <div v-else-if="!loadingStatus" class="text-center mt-5">
      <img src="@/assets/img/no_data.svg" class="img-fluid" width="250">
      <p class="h5 mt-3">{{ $t("views.my.tasks.noTasks") }}.</p>
    </div>
  </div>
</template>

<script>
import * as formatUtils from '../../composables/formatUtils'

export default {
  name: 'MeasureTracking',
  data () {
    return {
      filterName: '',
      filterResponsible: '',
      filterDue: '',
      switchConversion: true,
      tasksArray: { tasks: [] }
    }
  },
  computed: {
    filteredTasks () {
      const conversionValue = this.switchConversion ? 3 : 4
      const dueFilter = this.filterDue

      return this.tasksArray.tasks
        // Filter Measure-Title
        .filter(task =>
          task.title.toLowerCase().includes(this.filterName.toLowerCase())
        )

        // Filter Responsible
        .filter(task =>
          this.filterResponsible === '' || (task.responsible && task.responsible.name === this.filterResponsible)
        )

        // Filter Conversion
        .filter(task =>
          task.conversion <= conversionValue
        )

        // Filter Due
        .filter(task => {
          if (dueFilter === '') return true

          const validTo = new Date(task.validTo)
          const diffDays = Math.ceil((validTo - new Date()) / (1000 * 60 * 60 * 24))

          if (dueFilter === 'overdue') {
            return validTo < new Date()
          }

          if (dueFilter === '7') {
            return diffDays >= 0 && diffDays <= 7
          }

          if (dueFilter === '30') {
            return diffDays >= 0 && diffDays <= 30
          }

          if (dueFilter === '90') {
            return diffDays >= 0 && diffDays <= 90
          }

          return true
        })
    },
    uniqueResponsibles () {
      const tasks = Array.isArray(this.tasksArray.tasks) ? this.tasksArray.tasks : []

      const names = tasks
        .map(t => t?.responsible?.name || null)
        .filter(Boolean)

      return [...new Set(names)].sort((a, b) => a.localeCompare(b))
    },
    loadingStatus () {
      return this.$store.state.loadingStatus
    },
    actualYear () {
      const actualYear = new Date().getFullYear()
      return actualYear
    }
  },

  methods: {
    async getAllTasks () {
      this.$store.commit('SET_LOADING_STATUS', true)
      this.tasksArray = await this.$store.dispatch('getAllTasks', '')
      this.$store.commit('SET_LOADING_STATUS', false)
    },
    createLink (type, uuid) {
      let url = ''
      if (type === 'objective') url = '/objectives/manage/objectives?id=' + uuid
      if (type === 'project') url = '/projects/manage/projects?id=' + uuid
      if (type === 'kpi') url = '/monitoring/manage/kpis?id=' + uuid
      if (type === 'strategy') url = '/strategies/manage/strategies?id=' + uuid
      return url
    },
    formatPeriod (period) {
      return formatUtils.formatPeriod(period)
    },
    formatDate (date) {
      const userLocale = this.$store.state.user.settings?.language
      return formatUtils.formatDate(userLocale, date)
    },
    timeProgress (obj) {
      const start = new Date(obj.validFrom)
      const end = new Date(obj.validTo)
      const now = new Date()

      if (now < start) return 0
      if (now > end) return 100

      const total = end - start
      const elapsed = now - start

      return Math.round((elapsed / total) * 100)
    }
  },
  async created () {
    this.$store.commit('SET_LOADING_STATUS', true)
    this.tasksArray = await this.$store.dispatch('getAllTasks', '')
    this.$store.commit('SET_LOADING_STATUS', false)
  }
}
</script>

<style scoped>
.container {
  max-width: 1600px;
}
.col-Measure-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.select-th {
  background-color: transparent;
  border: 0;
  font-weight: bold;
}
</style>
<style lang="scss" scoped>
.progress-label {
  transform: translate(-50%, -50%);
}
.tab-content .progress {
  margin-top: 6px;
}
</style>
